// Dial codes for the international phone selector (searchable).
// `len` is the expected national-number length (used for validation & masking).
export type Country = { name: string; iso: string; dial: string; flag: string; len: number };

export const COUNTRIES: Country[] = [
  { name: 'United States', iso: 'US', dial: '+1', flag: '🇺🇸', len: 10 },
  { name: 'Canada', iso: 'CA', dial: '+1', flag: '🇨🇦', len: 10 },
  { name: 'United Kingdom', iso: 'GB', dial: '+44', flag: '🇬🇧', len: 10 },
  { name: 'Ireland', iso: 'IE', dial: '+353', flag: '🇮🇪', len: 9 },
  { name: 'Australia', iso: 'AU', dial: '+61', flag: '🇦🇺', len: 9 },
  { name: 'New Zealand', iso: 'NZ', dial: '+64', flag: '🇳🇿', len: 9 },
  { name: 'Mexico', iso: 'MX', dial: '+52', flag: '🇲🇽', len: 10 },
  { name: 'Germany', iso: 'DE', dial: '+49', flag: '🇩🇪', len: 11 },
  { name: 'France', iso: 'FR', dial: '+33', flag: '🇫🇷', len: 9 },
  { name: 'Spain', iso: 'ES', dial: '+34', flag: '🇪🇸', len: 9 },
  { name: 'Italy', iso: 'IT', dial: '+39', flag: '🇮🇹', len: 10 },
  { name: 'Netherlands', iso: 'NL', dial: '+31', flag: '🇳🇱', len: 9 },
  { name: 'Portugal', iso: 'PT', dial: '+351', flag: '🇵🇹', len: 9 },
  { name: 'India', iso: 'IN', dial: '+91', flag: '🇮🇳', len: 10 },
  { name: 'Brazil', iso: 'BR', dial: '+55', flag: '🇧🇷', len: 11 },
  { name: 'Japan', iso: 'JP', dial: '+81', flag: '🇯🇵', len: 10 },
  { name: 'China', iso: 'CN', dial: '+86', flag: '🇨🇳', len: 11 },
  { name: 'South Korea', iso: 'KR', dial: '+82', flag: '🇰🇷', len: 10 },
  { name: 'Philippines', iso: 'PH', dial: '+63', flag: '🇵🇭', len: 10 },
  { name: 'South Africa', iso: 'ZA', dial: '+27', flag: '🇿🇦', len: 9 },
  { name: 'Poland', iso: 'PL', dial: '+48', flag: '🇵🇱', len: 9 },
  { name: 'Sweden', iso: 'SE', dial: '+46', flag: '🇸🇪', len: 9 },
  { name: 'Norway', iso: 'NO', dial: '+47', flag: '🇳🇴', len: 8 },
  { name: 'Denmark', iso: 'DK', dial: '+45', flag: '🇩🇰', len: 8 },
  { name: 'Switzerland', iso: 'CH', dial: '+41', flag: '🇨🇭', len: 9 },
  { name: 'Austria', iso: 'AT', dial: '+43', flag: '🇦🇹', len: 10 },
  { name: 'Belgium', iso: 'BE', dial: '+32', flag: '🇧🇪', len: 9 },
];

export const US = COUNTRIES[0];
